import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box, Grid, Paper, Typography, Radio, FormControlLabel, RadioGroup, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react'
import { mergePlayers } from '../../../../api/index.js';
import useStyles from '../../../../styles/global-mui.js';
import DsasButton from '../../../components/DsasButton/DsasButton.js';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const MergePlayersPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const returnTo = location.state?.returnTo || '/sports/players'; // fallback

  const mergedPlayer = location.state?.mergedPlayer || {};
  const idsToDelete = location.state?.idsToDelete || [];

  const matchesUpdated = location.state?.matchesUpdated || 0
  const gamefactsUpdated = location.state?.gamefactsUpdated || 0

  // État pour stocker l'équipe sélectionnée
  const [selectedTeam, setSelectedTeam] = useState(null);

  const [openConfirmation, setOpenConfirmation] = useState(false);

  // Filtrer les équipes sans `endDate` et `isCountry` === false
  const selectableTeams = mergedPlayer.teamsSeason?.filter(team => !team.endDate && !team.team.isCountry) || [];

  const handleSelectTeam = (teamId) => {
    setSelectedTeam(teamId);
  };

  const executeMerge = () => {
    setOpenConfirmation(true); // Ouvre la popup de confirmation
};

const classes = useStyles();

  return (
    <Box>
      <Grid container spacing={2}>
      <Grid item xs={0} md={4}></Grid>
        <Grid item xs={12} md={4}>
          <Box className='centered-medium-wrapper'>
                  <h1 className='page-title'>Détails du Joueur Fusionné</h1>
          </Box>

          <Box elevation={3} sx={{ padding: 2 }}>
            {/* Informations du joueur */}
            {[
              { label: 'Prénom', value: mergedPlayer.firstname },
              { label: 'Nom', value: mergedPlayer.lastname },
              { label: 'Discipline', value: mergedPlayer.discipline },
              { label: 'Numéro', value: mergedPlayer.number },
              { label: 'Date de Naissance', value: mergedPlayer.birthday ? new Date(mergedPlayer.birthday).toLocaleDateString('fr-FR') : 'N/A' },
              { label: 'Nationalité', value: mergedPlayer.nationality },
              { label: 'Taille (cm)', value: mergedPlayer.size },
              { label: 'Poids (kg)', value: mergedPlayer.weight },
              { label: 'Position', value: mergedPlayer.positioning },
              { label: 'ID Externe', value: mergedPlayer.thirdPartyId },
              { label: 'Entité Externe', value: mergedPlayer.thirdPartyEntityId }
            ].map((field, index) => (
              <Box key={index} sx={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #ddd' }}>
                <Typography className={classes.customTypoColor}>{field.label} :</Typography>
                <Typography className={classes.customTypoColor}>{field.value || 'N/A'}</Typography>
              </Box>
            ))}
            </Box>
          </Grid>
          <Grid item xs={0} md={4}></Grid>

      </Grid>

      <Box className='padding-wrapper xxl-padding-left xxl-padding-right'>

            <Box className='centered-medium-wrapper'>
            <h3 className='page-title'>Historique des Transferts</h3>
            </Box>

            {/* Liste des transferts */}
            {mergedPlayer.teamsSeason?.sort(
            (a, b) => new Date(b.startDate) - new Date(a.startDate)
          ).map((teamInfo, idx) => (
              <Box
                key={idx}
                sx={{
                  border: '1px solid #ccc',
                  padding: '16px',
                  marginBottom: idx<mergedPlayer.teamsSeason.length-1 ? '16px' : '0',
                  backgroundColor: teamInfo.endDate ? '#f0f0f0' : 'white',
                  position: 'relative',
                  minHeight: '35px',
                  alignContent: 'center',                }}
              >
                <Grid container alignItems="center" spacing={2}>
                  <Grid item xs={12} sm={4} className='centered-column-wrapper'>
                    <Typography className={classes.customTypoColor} fontWeight="bold">
                      {teamInfo.team.name}
                    </Typography>
                  </Grid>

                  {/* Dates */}
                  <Grid item xs={12} sm={4} className='centered-column-wrapper'>
                    <Grid container spacing={2}>
                      <Grid item xs={6} className='centered-column-wrapper'>
                        <Typography className={classes.customTypoColor}>
                          {teamInfo.startDate && new Date(teamInfo.startDate).toLocaleDateString('fr-FR')}
                        </Typography>
                      </Grid>
                      <Grid item xs={6} className='centered-column-wrapper'>
                        <Typography className={classes.customTypoColor}>
                          {teamInfo.endDate ? new Date(teamInfo.endDate).toLocaleDateString('fr-FR') : 'Actuellement'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* Sélection d'une équipe actuelle */}
                  <Grid item xs={12} sm={4} className='centered-column-wrapper'>
                    {!teamInfo.endDate && !teamInfo.team.isCountry && (
                      <FormControlLabel className={classes.customTypoColor}
                        control={
                          <Radio
                            checked={selectedTeam === teamInfo.team._id}
                            onChange={() => handleSelectTeam(teamInfo.team._id)}
                          />
                        }
                        label="Équipe actuelle"
                      />
                    )}
                  </Grid>
                </Grid>
              </Box>
            ))}

      </Box>
          

      <Box className='centered-wrapper xxl-padding-left xxl-padding-right'>
        <Typography className={classes.customTypoColor} fontStyle="italic">Pour cette fusion vous allez :</Typography>
      </Box>
      <Box className='padding-wrapper xxl-padding-left xxl-padding-right'>


      <Grid container alignItems="center" spacing={2} className='padding-wrapper'>
                  <Grid item xs={12} sm={4} className={`centered-column-wrapper display-grid medium-padding ${classes.customHoverContainer}`}>
                    <Typography className={classes.customTypoColor} fontWeight="bold" justifySelf='center'>
                      Supprimer
                    </Typography>
                    <Typography className={classes.customTypoColor} justifySelf='center'>{idsToDelete.length} joueurs</Typography>
                  </Grid>


                  <Grid item xs={12} sm={4} className={`centered-column-wrapper display-grid medium-padding ${classes.customHoverContainer}`}>
                    <Typography className={classes.customTypoColor} fontWeight="bold" justifySelf='center'>
                      Modifier la feuille de match de
                    </Typography>
                    <Typography className={classes.customTypoColor} justifySelf='center'>{matchesUpdated} matchs</Typography>
                  </Grid>

                  <Grid item xs={12} sm={4} className={`centered-column-wrapper display-grid medium-padding ${classes.customHoverContainer}`}>
                    <Typography className={classes.customTypoColor} fontWeight="bold" justifySelf='center'>
                      Modifier les acteurs de
                    </Typography>
                    <Typography className={classes.customTypoColor} justifySelf='center'>{gamefactsUpdated} faits de jeu</Typography>
                  </Grid>
        </Grid>

      <Box className='medium-padding'>
      {selectableTeams.length && !selectedTeam && 
          <Typography className={classes.customTypoColor} justifySelf='center' fontSize="small" fontStyle="italic">Veuillez sélectionner une équipe pour poursuivre</Typography>
        }
         <Box className='centered-wrapper small-padding'>
              <DsasButton disabled={selectableTeams.length && !selectedTeam} label={'Valider la fusion'} icon={faCheck} onClick={executeMerge} variant = 'alternative' />
        </Box>
      </Box>

      {/* <Button onClick={executeMerge} disabled={selectableTeams.length && !selectedTeam}>Valider la fusion des joueurs</Button> */}

      </Box>

      <Dialog
        open={openConfirmation}
        onClose={() => setOpenConfirmation(false)}
      >
        <DialogTitle>Confirmation</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Êtes-vous certain de valider la fusion ? Vous ne pourrez pas revenir en arrière.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConfirmation(false)} color="secondary">
            Annuler
          </Button>
          <Button 
            onClick={async () => {
              await mergePlayers(mergedPlayer, idsToDelete, selectedTeam);
              setOpenConfirmation(false); // Fermer la popup après la fusion
              navigate(returnTo); // Rediriger après la fusion

            }} 
            color="primary" 
            variant="contained"
          >
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MergePlayersPage;
